export interface MenuItem {
  id: string;
  text: string;
  click?: () => void;
  icon?: string;
  class?: string;
  disabled?: boolean;
  title?: string;
  tag?: string;
  tabIndex?: number;
  route?: string;
}

export enum MenuType {
  AppVersion = 'appVersion',
  Database = 'database',
  EnableSync = 'enableSync',
  Guide = 'guide',
  Logout = 'logout',
  Maximizer = 'maximizer',
  Preferences = 'preferences',
  Refresh = 'refresh',
  Settings = 'settings',
  SyncStatus = 'syncStatus',
  SwitchAccount = 'switchAccount',
  SyncSharedMailboxWarning = 'syncSharedMailbox',
  ReInstallSync = 'reInstallSync',
  User = 'user',
}
